const SortNormal = () => (
  <>
    <path
      fill="currentColor"
      d="M4.5 17a.5.5 0 0 1 0-1h3.75a.5.5 0 0 1 0 1zm0-4.5a.5.5 0 0 1 0-1h9.366a.5.5 0 0 1 0 1zm0-4.5a.5.5 0 0 1 0-1h15a.5.5 0 0 1 0 1z"
    />
  </>
)
export default SortNormal
